import {AttrsSchema, Component, ConfigOptions} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {eventWasOutside} from 'common/util/dom';

import template from './index.jade';
import {TagAttrs, TagSize, TagTheme} from './types';
import css from './index.styl?inline';

export class Tag extends Component<null, TagAttrs> {
  static get attrsSchema(): AttrsSchema<TagAttrs> {
    return {
      ...super.attrsSchema,
      clickable: `boolean`,
      icon: `string`,
      removable: `boolean`,
      size: {type: `string`, default: TagSize.Default, enum: Object.values(TagSize)},
      'tag-name': `string`,
      theme: {type: `string`, default: TagTheme.Light, enum: Object.values(TagTheme)},
    };
  }

  get config(): ConfigOptions<null> {
    return {
      useShadowDom: true,
      css,
      template,
      helpers: {
        TagTheme,
        TagSize,
        remove: (ev) => {
          ev.stopPropagation();
          this.dispatchEvent(new CustomEvent(`remove`, {detail: {tagName: this.attr(`tag-name`)}}));
        },
        select: (ev) => {
          const removeTag = this.el.querySelector(`.remove-tag`);
          if (!removeTag || eventWasOutside(ev, removeTag)) {
            this.dispatchEvent(new CustomEvent(`select`, {detail: {tagName: this.attr(`tag-name`)}}));
          }
        },
      },
    };
  }
}

export const TagEl = defineAndMakeJsxFactory(`mp-tag`, Tag);
